module.exports = "/_next/static/images/d9308ed066422d4742821a72e60191d3-nubanker-bizarch@2x.jpg.webp";